
import React from 'react';
import { Modal, ModalProps } from 'antd';

const maskStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    minWidth: '100%',
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 1000,
    background: 'rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(50px)',
};

const CustomModal: React.FC<ModalProps> = (props) => {
    const { styles, children, ...modalProps } = props;

    return (
        <Modal
            {...modalProps}
            styles={{
                ...styles,
                mask: {
                    ...maskStyle,
                    ...styles?.mask,
                },
            }}
        >
            {children}
        </Modal>
    );
};

export default CustomModal;
